import { useParams } from "react-router-dom";
import Fetch from "../Fetch";
import ItemDelete from "./ItemDelete";
import { URL, TYPE, ACTION } from "../URL";

export default function FetchItemDelete() {
    let { id } = useParams();
    return (
        <Fetch
            url={new URL(ACTION.DETAIL, TYPE.ITEM, id)}
            renderSuccess={(data) => <ItemDelete data={data.data} />}
        />
    );
}
